import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { FormButtonComponent } from 'Shared/app/components/wfs-form-button/form-button.component';

export interface SaveDraftModalData {
  title: string;
  message: string;
  confirmCloseText: string;
  confirmContinueText: string;
  denyText: string;
  direction: string;
}

@Component({
  selector: 'wfs-save-draft-modal',
  templateUrl: './save-draft-modal.component.html',
  styleUrls: ['./save-draft-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [FormButtonComponent, MatDialogModule]
})
export class SaveDraftModalComponent {
  readonly #dialogRef = inject(MatDialogRef);
  readonly data = inject<SaveDraftModalData>(MAT_DIALOG_DATA);

  triggerEvent(value: string): void {
    this.#dialogRef.close(value);
  }
}
